export default __webpack_public_path__ + "static/media/available_page.20e78601.svg";